import { render, staticRenderFns } from "./PageOutageCenter.vue?vue&type=template&id=23ca47ac&scoped=true&"
import script from "./PageOutageCenter.vue?vue&type=script&lang=js&"
export * from "./PageOutageCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca47ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ca47ac')) {
      api.createRecord('23ca47ac', component.options)
    } else {
      api.reload('23ca47ac', component.options)
    }
    module.hot.accept("./PageOutageCenter.vue?vue&type=template&id=23ca47ac&scoped=true&", function () {
      api.rerender('23ca47ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/outagecenter/PageOutageCenter.vue"
export default component.exports